import { render, staticRenderFns } from "./ResourcesSection.vue?vue&type=template&id=557b2b68&scoped=true&"
import script from "./ResourcesSection.vue?vue&type=script&lang=js&"
export * from "./ResourcesSection.vue?vue&type=script&lang=js&"
import style0 from "./ResourcesSection.vue?vue&type=style&index=0&id=557b2b68&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "557b2b68",
  null
  
)

export default component.exports